import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(15),
  },
});

const ContentLoading = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Text
        variant={'h5'}
        text={'Loading data...'}
      />
      <LoadingIndicator
        color={'primary'}
      />
    </Box>
  );
};

ContentLoading.defaultProps = {
  className: '',
};

ContentLoading.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContentLoading);
